import React, {useEffect, useState} from 'react'
import {getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'
import {DatePickerComponent} from "../../ui/DatePickerComponent";

export const ProfileAdditionalQualificationForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [additionalQualification, setAdditionalQualification] = useState([])
    const [countries, setCountries]= useState([])

    const [showTypeError, setShowTypeError] = useState(false)
    const [showTitleError, setShowTitleError] = useState(false)

    const [backError, setBackError] = useState('');

    useEffect (() => {
        getResource('additional_qualification_types/get_active').then((data) => {
            console.log(`additional_qualification_types`)
            console.log(data.data)
            setAdditionalQualification(data.data)
        })
        getResource('countries/get_active').then((data) => {
            console.log(`countries`)
            console.log(data.data)
            setCountries(data.data)
        })
        setEntity(entityTemp);
    }, []);


    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-12 d-flex justify-content-around flex-wrap">
                            <div className="col-lg-7 col-12">
                                {(additionalQualification && additionalQualification.length > 0) &&
                                    (
                                        <Combo
                                            tooltipText="Одберете тип на квалификација"
                                            comboClass="combo-form"
                                            placeholder="Тип на квалификација"
                                            entity={(entity.additionalQualificationType) && entity.additionalQualificationType.name}
                                            onChange={(e) => {
                                                let chosenAdditionalQualificationType = {};
                                                chosenAdditionalQualificationType.id = e.target.value;
                                                setEntity({ ...entity, additionalQualificationType: chosenAdditionalQualificationType })
                                                setShowTypeError(false)
                                            }}
                                            onClear={() => setEntity({...entity, additionalQualificationType:null})}
                                            array={additionalQualification}/>)}
                                {showTypeError && <b>Ве молиме внесете одберете тип на квалификација</b>}

                                <input className="input-form w-100"  type="text" required={true} placeholder="Име"
                                       value={entity.title}
                                       onChange={(e) => {
                                           setEntity({...entity, title: e.target.value})
                                           setShowTitleError(false)
                                       }}
                                />
                                {showTitleError && <b>Ве молиме внесете име на квалификацијата</b>}

                                <input className="input-form w-100 mt-3"  type="text" required={true} placeholder="Институција"
                                       value={entity.institution}
                                       onChange={(e) => setEntity({...entity, institution: e.target.value})}
                                />

                                {(countries && countries.length > 0) &&
                                    <Combo
                                        tooltipText="Одберете држава"
                                        comboClass="combo-form"
                                        placeholder="Држава"
                                        entity={(entity.country) && entity.country.name}
                                        onChange={(e) => {
                                            let chosenCountry = {};
                                            chosenCountry.id = e.target.value;
                                            setEntity({ ...entity, country: chosenCountry })
                                        }}
                                        onClear={() => setEntity({...entity, country:null})}
                                        array={countries}/>}
                            </div>




                            <div className="col-lg-4 col-12 personal-info-form-container">
                                    <label className="w-100">Датум на почеток</label>
                                    <DatePickerComponent selectedDate={entity.startDate}
                                                         maxDate={new Date()}
                                                         placeholder="dd.mm.yyyy"
                                                         onChange={(e)=> setEntity({...entity, startDate:e})}/>

                                    <label className="w-100">Датум на завршување</label>
                                    <DatePickerComponent selectedDate={entity.endDate}
                                                         maxDate={new Date()}
                                                         placeholder="dd.mm.yyyy"
                                                         onChange={(e)=> setEntity({...entity, endDate:e})}/>

                            </div>

                            {backError && <b>{backError}</b>}
                            <div className="col-12 d-flex justify-content-around flex-wrap">
                                <div
                                    className="btn-form"
                                    onClick={()=>
                                    {setAddEntity(false)
                                        setEntityTemp({candidate: entity.candidate})
                                    }}
                                >Затвори</div>
                                <div
                                    className="btn-form"
                                    onClick={(e) => {
                                        if((entity.additionalQualificationType && entity.additionalQualificationType.id !== "0") &&
                                            (entity.title && entity.title.length > 0)) {
                                            updateResource('candidate_additional_qualifications', entity)
                                                .then((data) => {
                                                    console.log(data.data)
                                                    setAddEntity(false)
                                                    setEntityTemp({candidate: entity.candidate})
                                                    setUpdateEntity(!updateEntity)
                                                    setShowTypeError(false)
                                                    setShowTitleError(false)
                                                }).catch((exception) => {
                                                    console.log(exception.response.data.message)
                                                    setBackError(exception.response.data.message);
                                            })
                                        } else if (!entity.additionalQualificationType || entity.additionalQualificationType.id === "0") {
                                            setShowTypeError(true)
                                        } else if (!entity.title || entity.title === "") {
                                            setShowTitleError(true)
                                        }
                                    }}
                                >Зачувај</div>
                            </div>
                        </div>
            </>
            )
                }
        </div>
    )
}